import { AxiosResponse } from 'axios';
import {
  IGetAdminStudentsParams,
  IGetAdminStudentsResponse,
  IGetAdminStudentByIdResponse,
  IUpdateAdminStudentPayload,
  IUpdateAdminStudentResponse,
} from '../../../interface/classveew-admin/admin-management.interface';
import { adminInstance } from '../../api';
import { IStudentSoftDeleteResponseBody } from '../../../interface/studentModel';

/**
 * Get all students with pagination and filters
 */
export const getAdminStudents = async (
  params: IGetAdminStudentsParams,
): Promise<AxiosResponse<IGetAdminStudentsResponse>> => {
  const response = await adminInstance.get<IGetAdminStudentsResponse>('/students', {
    params,
  });
  return response;
};

/**
 * Get student by ID
 */
export const getAdminStudentById = async (
  studentId: string,
): Promise<AxiosResponse<IGetAdminStudentByIdResponse>> => {
  const response = await adminInstance.get<IGetAdminStudentByIdResponse>(`/students/${studentId}`);
  return response;
};

/**
 * Update student profile
 */
export const updateAdminStudent = async (
  studentId: string,
  data: IUpdateAdminStudentPayload,
): Promise<AxiosResponse<IUpdateAdminStudentResponse>> => {
  const response = await adminInstance.patch<IUpdateAdminStudentResponse>(
    `/students/${studentId}`,
    data,
  );
  return response;
};

export const adminDeleteStudent = async (
  id: string,
  orgId?: string,
): Promise<IStudentSoftDeleteResponseBody> => {
  try {
    const response = await adminInstance.delete<IStudentSoftDeleteResponseBody>(`/students/${id}`, {
      params: orgId ? { orgId } : undefined,
    });

    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};
